import React from 'react';
import cn from 'classnames';
import s from './StageIndicator.module.scss';

type StageIndicatorProps = {
  className?: string;
  style?: React.CSSProperties;
  children: React.ReactNode;
};

function StageIndicator({
  className,
  style,
  children,
}: StageIndicatorProps): JSX.Element {
  return (
    <div className={cn(s.stageIndicator, className)} style={style}>
      {children}
    </div>
  );
}
export default StageIndicator;
